import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps } from '../../../lib/types/types';
import { InputSelectComponent } from '../../FormInputs/InputSelect/InputSelectComponent';

export const FirstResponderStatus = ({
    value,
    isErrored,
    options,
    onChange,
    placeholder = '',
    intl,
    onKeyDown = undefined,
}: InputSelectComponentProps) => (
    <div className="sid-field sid-first-responder-status">
        <div className="sid-l-space-top-md" />
        <label htmlFor="sid-first-responder-status">
            <div id="sid-first-responder-status-label" className="sid-field__label sid-field__label--required sid-first-responder-status__label sid-l-space-btm-sm">
                <FormattedHTMLMessage
                    id="status"
                    defaultMessage="Status"
                />
            </div>
        </label>
        <InputSelectComponent
            fieldId="status"
            inputId="sid-first-responder-status"
            isErrored={isErrored}
            options={options}
            onChange={(status: FormSelectChoice) => onChange(status)}
            onKeyDown={onKeyDown}
            value={value}
            placeholder={placeholder || intl.formatMessage({ id: 'statusPlaceholder', defaultMessage: 'Status*' })}
        />
        {
            isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage
                        id="errorId.invalidStatus"
                        defaultMessage="Invalid first responder status"
                    />
                </div>
            ) : null
        }
    </div>
);

export const FirstResponderStatusComponent = injectIntl(FirstResponderStatus);
